module.exports = __webpack_public_path__ + "static/media/rotenso.5e5b427d.jpg";